// The end of a Veteran run.
//
// The old overlay had a modal for this (src/ui/veteranPanel.ts, openRunOver, now deleted),
// and it was the one player-facing moment the new shell had no replacement for
// — a run ending in silence is the worst possible outcome in the mode whose
// whole point is that the loss is explicable. So it is rebuilt here in the
// shell's markup, over the same data: every bird named, with the cause.

import { t } from '../../i18n';
import { scoreFor } from '../../sim/veteran';
import type { GameStateStore } from '../../core/store';
import { openSheet } from '../components/sheet';
import { div, h } from '../dom';
import type { Shell } from '../shell';

/** Flock-days, rounded the way the old panel rounded them. */
function formatFlockDays(days: number): string {
  return days < 10 ? days.toFixed(1) : String(Math.floor(days));
}

export function openRunOverSheet(shell: Shell, store: GameStateStore): void {
  const state = store.getState();
  const finalScore = Math.max(scoreFor(state), state.veteran.bestScore);
  const sheet = openSheet(shell, {
    title: t('runOver.title'),
    onClose: () => undefined,
  });

  sheet.body.replaceChildren(
    h('p', {
      class: 'cf-sub',
      text: t('runOver.summary', {
        days: formatFlockDays(state.veteran.flockDaysSurvived),
        size: state.flock.length,
        score: finalScore,
      }),
    }),
    div(
      { class: 'cf-cost' },
      ...state.flock.map((bird) =>
        div(
          { class: 'cf-cost__item cf-cost__item--bad' },
          h('span', {
            class: 'cf-cost__dot',
            attrs: { 'aria-hidden': 'true' },
          }),
          h('span', {
            text: bird.deathCause
              ? t('runOver.cause', { name: bird.name, cause: t(`death.${bird.deathCause}`) })
              : t('runOver.causeNone', { name: bird.name }),
          }),
        ),
      ),
    ),
  );
}
